import React, { useContext, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getQuartersMetricsData } from 'gqlQueries/priceSimulator';
import { quartersMetricsDataParser } from 'parser/priceSimulator/priceSimulatorDataParser';
import { UserContext } from 'contexts/ConfigContext';
import { ConfigKeys } from 'utils/Enums';
import { getConfig } from 'utils/helperMethods';
const errorMessage: string = 'Something went wrong!';

function useQuarterMetricData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<Array<any>>([]);
    const { appConfig } = useContext(UserContext);
    const { quarterMetricKeyMapping } = getConfig(ConfigKeys.PRICE_SIMULATOR, appConfig);

    const [fetchQuarterMetricData] = useLazyQuery(getQuartersMetricsData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getQuartersMetricsData } = payload;
            const data: any = quartersMetricsDataParser(getQuartersMetricsData, quarterMetricKeyMapping);
            setData(data);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchQuarterMetricData: (variables: any) => {
            setLoading(true);
            setError(null);
            fetchQuarterMetricData(variables);
        },
    };
}

export { useQuarterMetricData };
